import React from "react";
import classNames from "classnames";

import { VALIDITY_PERIOD } from "../../common/constants";
import ButtonGroup from "../../common/components/ButtonGroup.js";
import Label from "../../common/components/Label";

const ValidityPeriod = (props) => (
    <div className={classNames("pure-control-group", props.requiredClass)} >
        <Label>Validity Period</Label>
        <ButtonGroup className="x-validity-period-group"
                     onChange={props.onChange}
                     value={props.value}
                     buttons={[
                         { label:"1d", value: VALIDITY_PERIOD.VALIDITY_PERIOD_1D, className: "idea-attribute__input" },
                         { label:"2d", value: VALIDITY_PERIOD.VALIDITY_PERIOD_2D, className: "idea-attribute__input" },
                         { label:"1w", value: VALIDITY_PERIOD.VALIDITY_PERIOD_1W, className: "idea-attribute__input" },
                         { label:"1m", value: VALIDITY_PERIOD.VALIDITY_PERIOD_1M, className: "idea-attribute__input" },
                         { label:"3m", value: VALIDITY_PERIOD.VALIDITY_PERIOD_3M, className: "idea-attribute__input" },
                         { label:"6m", value: VALIDITY_PERIOD.VALIDITY_PERIOD_6M, className: "idea-attribute__input" },
                         { label:"1y+", value: VALIDITY_PERIOD.VALIDITY_PERIOD_1YPLUS, className: "idea-attribute__input" }
                     ]} />
    </div>
);
ValidityPeriod.propTypes = {
    onChange: React.PropTypes.func,
    requiredClass: React.PropTypes.string,
    value: React.PropTypes.string
};

export default ValidityPeriod;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/ValidityPeriod.js
 **/